(function() {
  'use strict';
  const spotlight = document.querySelector('.spotlight');
  const spotlightWrapper = document.querySelector('.spotlight-wrapper');
  if (spotlightWrapper) {
    if ('ontouchstart' in window) {
      spotlightWrapper.addEventListener('touchmove', (e) => {
        const rect = spotlightWrapper.getBoundingClientRect();
        const x = e.touches[0].clientX - rect.left;
        const y = e.touches[0].clientY - rect.top;
        spotlight.style.setProperty('--x', `${x}px`);
        spotlight.style.setProperty('--y', `${y}px`);
        e.preventDefault();
      });
      spotlightWrapper.addEventListener('touchend', (e) => {
        spotlight.style.setProperty('--x', `-9999px`);
        spotlight.style.setProperty('--y', `-9999px`);
      });
    } else {
      spotlightWrapper.addEventListener('mousemove', (e) => {
        const rect = spotlightWrapper.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        spotlight.style.setProperty('--x', `${x}px`);
        spotlight.style.setProperty('--y', `${y}px`);
      });
      spotlightWrapper.addEventListener('mouseleave', () => {
        spotlight.style.setProperty('--x', `-9999px`);
        spotlight.style.setProperty('--y', `-9999px`);
      });
    }
  }
})();
